import { connect } from 'react-redux'
import loader from 'hoc-react-loader'
import Visualizer from './Visualizer.jsx'
import { getTwitterId } from '../../redux/app/selectors'
import { hasErrorNotification } from '../../redux/notifications/selectors'
import { getVisualizerSize } from '../../redux/visualizer/selectors'
import {
    initialize,
    listenKeyboardEvents
} from '../../redux/visualizer/actions'
import {
    getMediaList,
    getCurrentMediaOriginalLocation
} from '../../redux/mediaList/selectors'
import {
    getCurrentMediaDescription,
    getCurrentMediaTitle,
} from '../../redux/currentMedia/selectors'
import {
    getNavigation,
    isNextMediaNavEnabled,
    isPrevMediaNavEnabled,
} from '../../redux/navigation/selectors'
import { ErrorContainer } from './Notifications/Error/Error'

const mapDispatchToProps = (dispatch, ownProps) => ({
    load: (ownProps) => dispatch(initialize(ownProps)),
    listenKeyboardEvents: (event) => dispatch(listenKeyboardEvents(event)),
})

const mapStateToProps = state => ({
    navigation: getNavigation(state),
    loaded: !!Object.keys(getMediaList(state)).length,
    error: hasErrorNotification(state),
    isPrevMediaNavEnabled: isPrevMediaNavEnabled(state),
    isNextMediaNavEnabled: isNextMediaNavEnabled(state),
    title: getCurrentMediaTitle(state),
    mediaOriginalLocation: getCurrentMediaOriginalLocation(state),
    twitterId: getTwitterId(state),
    description: getCurrentMediaDescription(state),

    // Size is mapped to props only to re-render visualizer component when window is resized
    // Do not remove
    size: getVisualizerSize(state),
})

const LoadedVisualizer = loader({ ErrorIndicator: ErrorContainer })(Visualizer)

export const VisualizerContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoadedVisualizer)
